// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"8b30b8e2","787":"0815f2dd"}[chunkId] + ".chunk.js";
};